module.exports = __webpack_public_path__ + "img/0ed200e.jpg";